var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3607 4.79091L6.36033 4.7911C4.971 5.51597 4.38811 7.19213 5.02467 8.62406C5.94094 10.6854 7.17122 12.5708 8.65599 14.222L9.77813 15.3442L17.2347 22.8007C19.1012 21.8944 20.697 20.5184 21.8695 18.8265L19.1181 16.0751C19.012 15.9188 18.8758 15.7798 18.7111 15.6682L8.33199 5.28905C7.89633 4.6471 7.04845 4.43203 6.3607 4.79091Z",
    fill: "#EBDCEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3873 14.0913C16.0033 13.8307 15.4988 13.832 15.1162 14.0946L14.5653 14.4727C13.9517 14.8938 13.1357 14.871 12.546 14.4171C11.9901 13.9892 11.4596 13.5305 10.9558 13.0444C10.4696 12.5406 10.011 12.0101 9.58313 11.4542C9.12919 10.8645 9.10636 10.0485 9.52749 9.43486L9.90558 8.88398C10.1681 8.50139 10.1695 7.99692 9.90891 7.61292L8.33203 5.28909C7.89642 4.64719 7.04855 4.43213 6.36075 4.79095L6.36033 4.79114C4.971 5.51602 4.38811 7.19217 5.02467 8.62411C5.94094 10.6854 7.17122 12.5709 8.65599 14.2221L9.77813 15.3442C11.4293 16.8289 13.3148 18.0592 15.3761 18.9755C16.8081 19.6121 18.4842 19.0292 19.209 17.6399L19.2092 17.6394C19.5681 16.9517 19.353 16.1038 18.7111 15.6682L16.3873 14.0913Z",
    fill: "#2E1834"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone1);
export default __webpack_public_path__ + "static/media/phone 1.d4a7ac9ce5f75f85c2623e1215627f64.svg";
export { ForwardRef as ReactComponent };